import { Injectable } from '@angular/core';
import { ApiGatewayService } from '../services/api-gateway.service';
import { ServiceObject } from 'src/app/model/service-object';
import { ReportDefinition } from 'src/app/model/reports/report-definition';
import { Filter } from 'src/app/model/reports/filter';

@Injectable({
  providedIn: 'root'
})
export class StaticReportBusinessService {

  constructor(private apiGatewayService: ApiGatewayService) {
  }

  public GetReportDefinition(reportId: string): Promise<ReportDefinition> {
    var servObj = new ServiceObject("Report", "StaticReport", "GetReportDefinition");
    servObj.Data = { reportId: reportId };
    return this.apiGatewayService.PostAction(servObj)
      .then(x => {
        if (!x.Success)
          throw new Error(x.Message);
        return Promise.resolve(x.Data);
      });
  }

  public GetReportData(reportId: string, filters:Filter[]): Promise<any> {
    var servObj = new ServiceObject("Report", "StaticReport", "GetReportData");
    servObj.Data = { reportId: reportId, filters:filters };
    return this.apiGatewayService.PostAction(servObj)
      .then(x => {
        if (!x.Success)
          throw new Error(x.Message);
        return Promise.resolve(x.Data);
      });
  }

  public GetFilterData(servObj: ServiceObject): Promise<any> {

    return this.apiGatewayService.PostAction(servObj)
      .then(x => {
        if (!x.Success)
          throw new Error(x.Message);
        return Promise.resolve(x.Data);
      });
  }

  public GetReportList(): Promise<ReportDefinition[]> {
    var servObj = new ServiceObject("Report", "StaticReport", "GetReportList");
    return this.apiGatewayService.PostAction(servObj)
      .then(x => {
        if (!x.Success)
          throw new Error(x.Message);
       // x.Data = [{ReportId:"AA",Title:"TestReport",Id:"AA",Group: "Grupo1",Permission:"*" },{ReportId:"AB",Title:"TestReport 2",Id:"AB",Group: "Grupo2",Permission:"*" }]
        return Promise.resolve(x.Data);
      });
  }



}
